<template>
    <the-mask
        v-if="mask"
        :value="value"
        :mask="mask"
        :masked="masked"
        :class="
            variant ||
            'w-full h-12 px-5 pr-10 bg-grey-100 text-blue-500 disabled:text-grey-200 disabled:cursor-not-allowed'
        "
        @input="$emit('input', $event)"
    />

    <input
        v-else
        :value="value"
        :class="
            variant ||
            'w-full h-12 px-5 bg-grey-100 text-blue-500 rounded-none disabled:text-grey-200 disabled:cursor-not-allowed'
        "
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
    components: { TheMask },

    props: {
        value: {
            type: [Number, String],
            default: ''
        },
        mask: {
            type: Array,
            default: null
        },
        masked: {
            type: Boolean,
            default: true
        },
        variant: {
            type: String,
            default: null
        }
    }
};
</script>
